import { render, staticRenderFns } from "./bgColor.vue?vue&type=template&id=0b330d79&scoped=true&"
import script from "./bgColor.vue?vue&type=script&lang=js&"
export * from "./bgColor.vue?vue&type=script&lang=js&"
import style0 from "./bgColor.vue?vue&type=style&index=0&id=0b330d79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b330d79",
  null
  
)

export default component.exports